import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
import { Advert } from '../../../interfaces/common';

@Component({
  selector: 'app-product-details-image-area',
  templateUrl: './product-details-image-area.component.html',
  styleUrls: ['./product-details-image-area.component.scss'],
})
export class ProductDetailsImageAreaComponent {
  @Input({ required: true }) public advert!: Advert;

  public showImgIndex?: number; // if this is defined then we are showing image in Modal
  private enableClickListener: boolean = false;

  @ViewChild('swiper', { static: false }) private swiper?: SwiperComponent;

  public closeModal() {
    this.showImgIndex = undefined;
    this.enableClickListener = false;
  }

  /**
   * CHANGE IMAGE FUNCTION
   * selectImage();
   */
  public onSelectImage(index: number) {
    if (this.swiper?.swiperRef) {
      // swiper indexes starts at `1` while @for indexes starts at 0
      // video slide is placed before image slides
      // that's why we need to add `2` to index instead of 1
      this.swiper.swiperRef.slideTo(index + (this.advert.videoUrl ? 2 : 1));
    }
  }

  public showImages(index: number) {
    // swiper indexes starts at `1` while @for indexes starts at 0
    this.showImgIndex = index + 1;
    setTimeout(() => {
      this.enableClickListener = true;
    }, 100);
  }

  @HostListener('document:keydown', ['$event'])
  private onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.showImgIndex !== undefined)
      this.closeModal();
  }

  @HostListener('document:click', ['$event'])
  private clickOutside(event: { target: HTMLElement }) {
    if (
      [
        'swiper-product-image',
        'swiper-button-next',
        'swiper-button-prev',
      ].every(cls => !event.target.classList.contains(cls)) &&
      this.enableClickListener
    )
      this.closeModal();
  }
}
